webpackJsonp([25403319872112],{

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookConnect = __webpack_require__(30);
	
	var _LoreHookConnect2 = _interopRequireDefault(_LoreHookConnect);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookConnect2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'blueprints'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Extend or override the built-in blueprints. This is helpful if you want to change the interface for a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getState'
	      ),
	      ' method call.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Each blueprint is responsible for:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Validating the parameters passed to the getState method'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Extracting the desired data from the Redux Store'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '[optional]'
	        ),
	        ' Calling the appropriate action if that data does not exist'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore has seven built-in blueprints:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import all from \'lore-hook-connect/es/blueprints/all\';\n      import byCid from \'lore-hook-connect/es/blueprints/byCid\';\n      import byId from \'lore-hook-connect/es/blueprints/byId\';\n      import find from \'lore-hook-connect/es/blueprints/find\';\n      import findAll from \'lore-hook-connect/es/blueprints/findAll\';\n      import first from \'lore-hook-connect/es/blueprints/first\';\n      import singleton from \'lore-hook-connect/es/blueprints/singleton\';\n\n      blueprints: {\n        all,      // used for calls like getState(\'tweet.all\')\n        byCid,    // used for calls like getState(\'tweet.byCid\')\n        byId,     // used for calls like getState(\'tweet.byId\')\n        find,     // used for calls like getState(\'tweet.find\')\n        findAll,  // used for calls like getState(\'tweet.findAll\')\n        first,    // used for calls like getState(\'tweet.first\')\n        singleton // used for calls like getState(\'currentUser\')\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To illustrate how to override a blueprint, let\'s examine the default syntax to fetch a model by id, which looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      getState(\'tweet.byId\', {\n        id: 1\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now let\'s say you wanted to modify the syntax to use a \'where\' clause, to make it similar to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'find'
	      ),
	      ' blueprint like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      getState(\'tweet.byId\', {\n        where: {\n          id: 1\n        }\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You could achieve that by overriding the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'byId'
	      ),
	      ' blueprint with the implementation below.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      blueprints: {\n        byId: {\n          defaults: {\n            where: {\n              id: null\n            }\n          },\n\n          verifyParams: function(params) {\n            if (!params.where.id) {\n              throw new Error(\'Missing required field: id\');\n            }\n          },\n\n          getPayload: function(reducerState, params) {\n            const key = params.where.id;\n            return reducerState[key];\n          },\n\n          callAction: function(action, params) {\n            const id = params.where.id;\n            return action(id).payload;\n          }\n        }\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-connect-config-blueprints-js-5b1e255bc19145d6554c.js